interface SocialLinkButtonProps {
    href: string;
}

export const SocialLinkButton: React.FC<SocialLinkButtonProps> = (props) => {
    return <div className="social-button">
        <a href={props.href} target="_blank" rel="noreferrer" className="social-button__link">
            {props.children}
        </a>
    </div>
}

interface SocialButtonProps {
    id?: string;
    onClick: () => void;
    className?: string;
}

export const SocialButton: React.FC<SocialButtonProps> = (props) => {
    return <div id={props.id || ""} className={`social-button ${props.className || ""}`}>
        <div onClick={props.onClick} className="social-button__link">
            {props.children}
        </div>
    </div>
}